module.exports = mobx;


//////////////////
// WEBPACK FOOTER
// external "mobx"
// module id = 74
// module chunks = 1 5 6 7